<template>
    <div>
        <NavBar />

        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Create Contact List
                    </h1>
                </div>
            </header>
        </div>

        <div class="container mx-auto">
            <div class="max-w-full mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0">
                    <form class="w-full max-w-lg" @submit.prevent="createContactList">
                        <div class="flex flex-wrap -mx-3 mb-6">
                            <div class="w-full px-3 mb-6 md:mb-0">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                    Name
                                </label>
                                <input class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="Marketing list" v-model="listName" required />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-3 mb-6">
                            <div class="w-full px-3 mb-6 md:mb-0">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                    First Name
                                </label>
                                <input
                                    v-model="firstName"
                                     class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="Jane" required />
                            </div>
                            <div class="w-full px-3 mb-6 md:mb-0">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                    Last Name
                                </label>
                                <input v-model="lastName" class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="Doe" required />
                            </div>
                            <div class="w-full px-3 mb-6 md:mb-0">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                    Phone Number
                                </label>
                                <input v-model="destination" class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="0412345678" required />
                            </div>
                        </div>
                        <button class="bg-green-500 hover:bg-green-700 text-white font-bold text-sm py-3 px-4 shadow rounded"> Create </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { api } from "../store/http";

export default {
    name: "CreateContactList",
    components: {
        NavBar,
    },
    data() {
        return {
            listName: "",
            firstName: "",
            lastName: "",
            destination: "",
        }
    },
    methods: {
        createContactList(e) {
            const data = new FormData();

            data.append("create_list_request[description]", this.listName);
            data.append("create_list_request[recipients][0][first_name]", this.firstName);
            data.append("create_list_request[recipients][0][last_name]", this.lastName);
            data.append("create_list_request[recipients][0][destination]", this.destination);

            api.post("lists", data)
                .then(response => {
                    alert("done!");
                })
            ;
        }
    }
}
</script>